import postParse from '@/plans/EVENT_SAAS/post';

export default postParse;
